export default __webpack_public_path__ + "img/mastodon.c1aa3aa1.svg";